import dictionary from './Betting.dictionary.json';

export const enum MatchRowStatus {
  COLLAPSED = 0,
  LOADING = 1,
  EXPANDED = 2,
}

export const MATCH_HEADER = {
  title: dictionary.matchHeaderTitle,
  subtitleCollapsed: dictionary.headerCollapsedSubtitle,
  subtitleExpanded: dictionary.headerExpandedSubtitle,
};

export const OUTRIGHT_HEADER = {
  title: dictionary.outrightHeaderTitle,
  subtitleCollapsed: dictionary.headerCollapsedSubtitle,
  subtitleExpanded: dictionary.headerExpandedSubtitle,
};

export const StakeTypeGroup = {
  530: 'win',
  805: 'matchWin',
  609: 'doubleOutcome',
  606: 'total',
  608: 'totalAsia',
  745: 'totalCorners',
  605: 'handicap',
  607: 'handicapAsia',
  746: 'handicapCorners',
  806: 'nextGoal',
  625: 'moreTotal',
  626: 'moreHandicap',
} as const;
